// Display helpers for the deleted-clips panel (GameDetail). Kept pure + exported
// so they can be unit-tested — the admin UI itself is JWT-gated and not driven
// headlessly (see vitest.config.ts).

/** Seconds → "M:SS". */
export function formatDuration(seconds: number): string {
  const total = Math.max(0, Math.round(seconds))
  const m = Math.floor(total / 60)
  const s = total % 60
  return `${m}:${String(s).padStart(2, "0")}`
}

/**
 * Human-readable length for a deleted clip. The backend computes `length_seconds`
 * (a virtual slice's window, or a whole-file clip's source duration) — the admin
 * only formats it; null means the duration is unknown ("Full file"). Keeping the
 * derivation server-side avoids duplicating the video_meta duration precedence here.
 */
export function deletedClipLength(clip: { length_seconds: number | null }): string {
  if (clip.length_seconds == null) return "Full file"
  return formatDuration(clip.length_seconds)
}
